import {Component, Input} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';


@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.less'],
})
export class CheckboxComponent extends CustomFormControl {
    @Input() invalid = false;
    @Input() label: string;
    @Input() value: string;
    public size = undefined;

    get checked() {
        if (Array.isArray(this.control.value)) {
            return this.control.value.includes(this.value);
        } else if (this.value) {
            return this.control.value === this.value;
        }
        return this.control.value;
    }

    getNewControlValue(checked) {
        if (Array.isArray(this.control.value)) {
            return checked
                ? [...this.control.value, this.value]
                : this.control.value.filter(value => value !== this.value);
        }
        if (checked) {
            return this.value
                ? this.value
                : true;
        }
        return false;
    }

    onChange(event) {
        this.control.setValue(this.getNewControlValue(event.target.checked));
    }
}
